// extracted by mini-css-extract-plugin
module.exports = {"FundingWalletDetails":"fundingWalletDetails_FundingWalletDetails__3rvFk"};